import { render, staticRenderFns } from "./TermsAndConditionsPayments.vue?vue&type=template&id=e0a16196&"
import script from "./TermsAndConditionsPayments.vue?vue&type=script&lang=ts&"
export * from "./TermsAndConditionsPayments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports